import { useEffect, useState } from 'react';
import styled from 'styled-components';

const Button = styled.button`
  position: fixed;
  right: max(16px, env(safe-area-inset-right));
  bottom: max(16px, env(safe-area-inset-bottom));
  z-index: 9999;

  width: 40px;
  height: 40px;
  border-radius: 50px;

  background: rgba(0, 0, 0, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #fff;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);

  opacity: ${(p) => (p.$visible ? 1 : 0)};
  pointer-events: ${(p) => (p.$visible ? 'auto' : 'none')};
  transform: translateY(${(p) => (p.$visible ? '0' : '14px')});
  transition: 0.25s ease;

  &:hover {
    background: rgba(241, 134, 13, 0.95);
    box-shadow: 0 0 0 4px rgba(241, 134, 13, 0.25), 0 10px 28px rgba(0, 0, 0, 0.45);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 5l-7 7m7-7l7 7m-7-7v14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const getTop = () => {
      const se = document.scrollingElement;
      const seTop = se ? se.scrollTop : 0;
      const winTop = window.scrollY || 0;
      return Math.max(seTop, winTop);
    };

    const onScroll = () => {
      setVisible(getTop() > 0);
    };

    // слушаем оба источника — без угадываний
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });

    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('scroll', onScroll);
    };
  }, []);

  const scrollToTop = () => {
    const se = document.scrollingElement;
    if (se) se.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Button onClick={scrollToTop} $visible={visible} aria-label="Scroll to top">
      <ArrowIcon />
    </Button>
  );
}

export default ScrollToTopButton;
